export const ResultsGridMasonry = {
	data() {
		return {
			readyToShow: false,
			msnry: null,
			rt: null
		}
	},
	methods: {
		handleToggleHeightChange(el, height) {
			el.parentNode.style.height = height + 'px'
			this.reorganizeCards();
		},
		handleWindowResize() {
			clearTimeout(this.rt)
			this.rt = setTimeout(() => {
				this.reorganizeCards()
			}, 800)
		},
		reorganizeCards() {
			if (this.msnry === null) return;
			this.msnry.layout();
		},
		initMasonry() {
			imagesLoaded(this.$refs.resultsWrapperInner, () => {
				this.msnry = new Masonry( this.$refs.resultsWrapperInner, {
					itemSelector: '.item',
					originTop: true,
					horizontalOrder: true,
					percentPosition: true
				});
				this.readyToShow = true
			});
		},
		updateMasonry() {
			imagesLoaded(this.$refs.resultsWrapperInner, () => {
				this.msnry.reloadItems()
				this.msnry.layout()
			});
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleWindowResize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleWindowResize)
	},
	watch: {
		results(newVal) {
			if ( newVal.length > 0 ) {
				if ( this.msnry === null) {
					this.initMasonry();
				} else {
					this.updateMasonry();
				}
			}
		}
	}


}